<template>
  <div>
    <h3 class="primary--text font-weight-medium">
      <v-icon
        class="display-24 primary--text font-weight-medium hc-ico"
        :class="icon"
      ></v-icon>
      <span class="display-36">{{ catName }}</span>
      <!-- <span class="display-18"> ({{catJobs}} משרות)</span> -->
    </h3>
  </div>
</template>

<script>
export default {
  props: {
    catName: {
      type: String,
      required: false,
      default: '',
    },
    catCode: {
      type: Number,
      required: false,
      default: 0,
    },
    catJobs: {
      type: Number,
      required: false,
      default: 0,
    },
    icon: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>
<style scoped>
@media only screen and (min-width: 600px) {
  .hc-ico {
    vertical-align: unset;
  }
}
</style>
